import React from 'react';
import styles from './SpeechIndicator.module.css';

const SpeechIndicator = ({ isAssistantSpeaking }) => {
  return (
    <div 
      className={styles.speechBubble}
      style={{ backgroundColor: isAssistantSpeaking ? '#FFD700' : '#4CAF50' }}
      title={isAssistantSpeaking ? 'Assistant is speaking' : 'Speech ready'}
    />
  );
};

export default SpeechIndicator;